import * as React from "react"
import { cn } from "@/lib/utils"
import { ChevronDownIcon } from "lucide-react"

import { inputVariants } from "@/components/ui/input"

/** `default` is a deprecated alias for `md`. */
type NativeSelectSize = "sm" | "md" | "lg" | "default"

function NativeSelect({
  className,
  size = "md",
  ...props
}: Omit<React.ComponentProps<"select">, "size"> & { size?: NativeSelectSize }) {
  return (
    <div
      className="group/native-select relative w-fit"
      data-slot="native-select-wrapper"
      data-size={size}
    >
      <select
        data-slot="native-select"
        data-size={size}
        className={cn(
          inputVariants({ size }),
          "cursor-default appearance-none pr-8 hover:bg-accent disabled:hover:bg-muted",
          size === "sm" && "pr-7",
          className,
        )}
        {...props}
      />
      <ChevronDownIcon
        className="pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2 text-muted-foreground select-none group-data-[size=sm]/native-select:right-2"
        aria-hidden="true"
        data-slot="native-select-icon"
      />
    </div>
  )
}

function NativeSelectOption({
  className,
  ...props
}: React.ComponentProps<"option">) {
  return (
    <option
      data-slot="native-select-option"
      className={cn("bg-popover text-popover-foreground", className)}
      {...props}
    />
  )
}

function NativeSelectOptGroup({
  className,
  ...props
}: React.ComponentProps<"optgroup">) {
  return (
    <optgroup
      data-slot="native-select-optgroup"
      className={cn("bg-popover text-popover-foreground", className)}
      {...props}
    />
  )
}

export { NativeSelect, NativeSelectOptGroup, NativeSelectOption }
